import VueIcon from '@ant-design/icons-vue';

export function setTwoToneColor(primaryColor) {
  return VueIcon.setTwoToneColors({
    primaryColor: primaryColor
  });
}

export function getTwoToneColor() {
  var colors = VueIcon.getTwoToneColors();
  return colors.primaryColor;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/icon/twoTonePrimaryColor.js
// module id = null
// module chunks = 